import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useCurrentUserIdAsync } from '#src/app/shared/hooks/session';
import type { ShareAction, ShareChannel } from '#src/app/shared/hooks/share';
import { TRACK_NATIVE_SHARE_INTENT, useShareActions } from '#src/app/shared/hooks/share';
import { isLoaded } from '#src/app/shared/utils/async';

import { useGetTrackingData } from './useGetTrackingData';
import { usePetitionMobileNativeShareLink } from './usePetitionMobileNativeShareLink';

type Channel = 'mobileNativeShare';

type UseMobileNativeShareReturn = ShareAction<Channel> | null;

export function useMobileNativeShare(): UseMobileNativeShareReturn {
	const {
		data: {
			petition: { id: petitionId, user: petitionUserId },
		},
	} = usePetitionDetailsPageData();

	const currentUserState = useCurrentUserIdAsync();
	const currentUserId = isLoaded(currentUserState) ? currentUserState.value : undefined;

	// isLoading is intentionally not surfaced: the button is off-screen during initial render,
	// so the query resolving asynchronously after mount is not a visible pop-in for users.
	const { link } = usePetitionMobileNativeShareLink();
	const getContent = (_channel: ShareChannel) => '';
	const getTrackingData = useGetTrackingData(petitionUserId, currentUserId, petitionId);
	const options = {
		trackingEventName: 'share_petition',
		getContent,
		getTrackingData,
		config: { mobileNativeShare: TRACK_NATIVE_SHARE_INTENT },
	};

	const actions = useShareActions(link ? [link] : [], options);

	return (actions[0] ?? null) as UseMobileNativeShareReturn;
}
